import React from "react";
import { Modal, Button, Card, Alert } from "react-bootstrap";

function CauseListModal({
  responseCauseList,
  errorString,
  submitError,
  show,
  handleClose,
}) {
  // Check if responseCauseList is defined and contains data
  const hasData =
    responseCauseList &&
    responseCauseList.data &&
    responseCauseList.data.length > 0;

  // If there's an error in the API response, display the error message
  if (submitError) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
            <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">
            {responseCauseList?.error || "An error occurred. Please try again."}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's an error message in the API response, display the error message
  if (errorString !== "") {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
          <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorString}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's no data, do not render anything
  if (!hasData) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>No Data</Modal.Title>
          <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            Causelist not found of selected date & court no.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Extract the first item from the response for easier access
  const causeList = responseCauseList.data[0]; // Updated to access `data`

  // Check if causeList is defined and contains the expected properties
  if (!causeList.sheeting_judges || !causeList.case_details_array) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
          <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">Data structure is not as expected.</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header  onClick={handleClose}>
        <Modal.Title>Cause List Details</Modal.Title>
        <Button className="btn-secondary">X</Button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 text-dark h5 pt-3 text-center">
          {causeList ? (
            <>
              <h5>
                RAILWAY CLAIMS TRIBUNAL/रेल दावा अधिकरण, {causeList.bench_name}
              </h5>

              <div className="h6">
                Listing Date:{" "}
                <span className="bold">{causeList.listing_date}</span>
              </div>
              <div className="h6">
                Bench Nature:{" "}
                <span className="bold">{causeList.bench_nature}</span>
              </div>
            </>
          ) : (
            <Alert variant="warning">No data found.</Alert>
          )}

          {/* <h5>Judges:</h5>. */}
          {causeList.sheeting_judges && causeList.sheeting_judges.length > 0 ? (
            causeList.sheeting_judges.map((judge, index) => (
              <div key={index}>
                Bench No:<strong> {judge.bench_no}</strong>
                <br />
                Judges: <strong>{judge.judges}</strong>
                <br />
                Time: <strong>{judge.benchtime}</strong>
              </div>
            ))
          ) : (
            <Alert variant="warning">No judges found.</Alert>
          )}
        </div>

        <Card className="mb-3">
          <Card.Body>
            <Card.Text>
              <div className="col-md-12 p-0">
                <div className="table-responsive">
                  <table className="table table-striped common-table modal-custom-table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Case Title</th>
                        <th>Case No.</th>
                        <th>Main Party</th>
                        <th>Claim Type</th>
                        <th>Petitioner Advocate</th>
                        <th>Filing No</th>
                        <th>Proceeding Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {causeList.case_details_array &&
                      causeList.case_details_array.length > 0 ? (
                        causeList.case_details_array.map(
                          (caseDetail, index) => {
                            return (
                              <tr key={caseDetail.case_no}>
                                <td>{index + 1}</td>{" "}
                                {/* Display the row index */}
                                <td>{caseDetail.case_title}</td>
                                <td>{caseDetail.case_no}</td>
                                <td>{caseDetail.main_party}</td>
                                <td>{caseDetail.claim_type}</td>
                                <td>{caseDetail.pet_adv}</td>
                                <td>{caseDetail.filing_no}</td>
                                <td>{caseDetail.proceeding_type}</td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <Alert variant="warning">No case details found.</Alert>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>

        {causeList.allProceeding && causeList.allProceeding.length > 0 && (
          <>
            <h5 className="mt-4">Proceedings:</h5>
            <div className="col-md-12 p-0">
              <div className="table-responsive">
                <table className="table table-striped common-table modal-custom-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Listing Date</th>
                      <th>Next Listing Date</th>
                      <th>Listing Purpose</th>
                      <th>Today's Action</th>
                      <th>Remarks</th>
                      <th>Order File</th>
                    </tr>
                  </thead>
                  <tbody>
                    {causeList.allProceeding.map((proceeding, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{proceeding.listing_date || "N/A"}</td>
                        <td>{proceeding.next_listing_date || "N/A"}</td>
                        <td>{proceeding.listing_purpose || "N/A"}</td>
                        <td>{proceeding.todays_action || "N/A"}</td>
                        <td>{proceeding.remarks || "N/A"}</td>
                        <td>{proceeding.order_file || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CauseListModal;
